import { Observable } from 'rxjs/internal/Observable';
import { Directive } from '@angular/core';
import { LogService } from './log.service';
import { ValidationError } from './validation.error';
import { BusinessLogicError } from './business-logic.error';
import { HttpClient } from '@angular/common/http';

@Directive()
export abstract class UseCase<REQUEST extends Object, RESPONSE extends Object> {

    enableStatusLogs = false;

    constructor(protected _logService: LogService, protected _http: HttpClient, enableStatusLogs = false) {
        this.enableStatusLogs = enableStatusLogs;
    }

    execute(request: REQUEST | void): Observable<RESPONSE> | RESPONSE | void {
        this._logInitState(request);
        let response: RESPONSE | void;
        try {
            if (request) {
                this.validate(request);
            }
            response = this.executeBusinessLogic(request);
        } catch (error) {
            if (error instanceof Error) {
                this._handleErrors(error);
            }
        }
        this._logProcessedState(response);
        if (response) {
            return response;
        }
    }

    private _logInitState(request: REQUEST | void): void {
        if (this.enableStatusLogs) {
            if (request) {
                this._logRequest(request);
            } else {
                this._logService.info(`${this.constructor.name} has been started!`);
            }
        }
    }

    private _logRequest(request: REQUEST | void): void {      
        this._logService.info(`${this.constructor.name} has been started with request: ${JSON.stringify(request)}`);
    }

    protected validate(request: REQUEST) {}

    protected abstract executeBusinessLogic(request: REQUEST | void): RESPONSE | void;

    private _handleErrors(error: Error): void {
        if (error instanceof ValidationError) {
            this._logService.warn('Validation error:' + error);
        } else if (error instanceof BusinessLogicError) {
            this._logService.error('Business logic exception happened: ' + error);
        } else if (error instanceof Error) {
            this._logService.error('Unknown excpetion happened: ' + error);
        }
    }

    private _logProcessedState(response: Observable<RESPONSE> | RESPONSE | void): void {
        if (this.enableStatusLogs) {
            if (response) {
                this._logResponse(response);
            } else {
                this._logService.info(`${this.constructor.name} has been processed!`);
            }
        }
    }

    private _logResponse(response: Observable<RESPONSE> | RESPONSE | void): void {
        if (response instanceof Observable<RESPONSE>) {
            (response as Observable<RESPONSE>).subscribe(
                (responseValue: RESPONSE) => {
                    this._logService.info(`${this.constructor.name} has been processed with response: ${JSON.stringify(responseValue)}`);
                }
            )
        } else {
            this._logService.info(`${this.constructor.name} has been processed with response: ${JSON.stringify(response)}`);
        }
    }
}

